import React from 'react';
import styles from './ProductVisualCheckDetails.module.scss';
import { useTranslation } from 'react-i18next';
import { DynamicComponentProps } from '@/types/ModuleComponentProp.type';


export const ProductVisualCheckDetailsFull: React.FC<DynamicComponentProps> = ({ inspection, structure, onValueChange }: DynamicComponentProps) => {
    const { t: translate } = useTranslation();


    return (
        <div className={styles.formContainer}>
            <h2 className={styles.header}>{translate(structure.header || 'Product Visual Check Details')}</h2>
            <div className={styles.inputRow}>
                <div className={styles.inputGroup}>
                    <p className={styles.heading} >{translate('Submission Number')}</p>
                    <p className={styles.value}>{inspection.submissionNumber}</p>

                </div>
                <div className={styles.inputGroup}>
                    <p className={styles.heading}>{translate('Sample Size')}</p>
                    <p className={styles.value}>{inspection.sampleSize} </p>
                </div>
            </div>
            <div className={styles.inputRemoveQty}>
                <label className={styles.label} htmlFor="removedQuantity">{translate('Removed Quantity')}</label>
                <input type="number" id="removedQuantity" name="removedQuantity" value={inspection.removedQuantity} onChange={onValueChange} />
            </div>
        </div>
    )
}